const r = {
  arrowDown: "ArrowDown",
  arrowUp: "ArrowUp",
  enter: "Enter",
  escape: "Escape",
  space: " ",
  tab: "Tab"
};
export { r as keys };
